import { render } from "./cell_custom.vue?vue&type=template&id=f46a9f62"
import script from "./cell_custom.vue?vue&type=script&lang=ts"
export * from "./cell_custom.vue?vue&type=script&lang=ts"
script.render = render

export default script